import { HashRouter, Routes, Route } from 'react-router-dom';
import MaintainanceScreen from './components/MaintainanceScreen';
import LandingPage from './components/LandingPage/LandingPage';
import LaunchingRocket from './components/LaunchingRocket/LaunchingRocket';
import Mars from './components/Mars/Mars';
import { usePortfolioData } from './hooks/usePortfolioData';

function App() {
  const { data, loading } = usePortfolioData();

  console.log("Firebase Data:", data);
  console.log("Maintenance Status:", data?.maintenance); // Explicit check

  // 1. Loading State (Checking System Status)
  if (loading) {
    return (
      <div style={{ height: '100vh', background: 'black', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0f0', fontFamily: 'monospace' }}>
        <h2>&gt; ESTABLISHING SECURE CONNECTION...</h2>
      </div>
    );
  }

  // 2. Maintenance Mode (Dynamic from Firestore)
  // Assuming the user added 'maintenance' field at the root of the document
  if (data?.maintenance) {
    return (
      <MaintainanceScreen redirectUrl="https://himanshu-vishwas.github.io/himanshu-vishwas-react/" />
    );
  }

  // 3. Active Mode
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/launch" element={<LaunchingRocket />} />
        <Route path="/mars" element={<Mars />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
